module.exports = __webpack_public_path__ + "img/motor_no69.a5e732ba.jpg";